'use client';

import algoliaAnalytics from 'search-insights';

import { algoliaClient, recommendClient } from './algoliaInterceptor';
import { ALGOLIA_CONFIDENCE_THRESHOLD } from './constants';

export { algoliaClient, recommendClient };

export const algoliaAnalyticsClient = algoliaClient.initAnalytics({ region: 'us' });

export const aa = algoliaAnalytics;

export const ALGOLIA_CONFIDENCE_SCORE_THRESHOLD = ALGOLIA_CONFIDENCE_THRESHOLD;
